"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../../../../../hooks");
var ConfigProvider_1 = require("../../../../../providers/ConfigProvider");
var either_1 = require("../../../../../utils/either");
var Button_1 = __importDefault(require("../../../../Button/Button"));
var LoupeIcon_1 = __importDefault(require("../../../../Icon/LoupeIcon"));
var Padder_1 = require("../../../../Padder");
var Form_1 = __importDefault(require("../../../Form"));
var Dropdown_1 = __importDefault(require("../../../inputs/Dropdown"));
var DruhyOsobyUkonOption_1 = __importDefault(require("./DruhyOsobyUkonOption"));
var StyledDruhyOsob = styled_components_1.default(DruhyOsobyUkonOption_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #fff;\n  padding: 1rem;\n  position: relative;\n"], ["\n  background-color: #fff;\n  padding: 1rem;\n  position: relative;\n"])));
var DropdownHeader = styled_components_1.default.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 28px;\n  font-weight: 400;\n  color: #000000;\n  margin-top: 0;\n"], ["\n  font-size: 28px;\n  font-weight: 400;\n  color: #000000;\n  margin-top: 0;\n"])));
var ButtonsWrap = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  text-align: center;\n\n  button {\n    margin-top: 1rem;\n  }\n"], ["\n  align-items: center;\n  text-align: center;\n\n  button {\n    margin-top: 1rem;\n  }\n"])));
var DropdownWrap = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: #eaeff3;\n  padding: 20px;\n"], ["\n  background: #eaeff3;\n  padding: 20px;\n"])));
var mapToOptions = ramda_1.map(function (tlumocnik) { return ({
    value: tlumocnik.id,
    label: tlumocnik.jmeno + " " + tlumocnik.prijmeni || undefined,
    data: tlumocnik,
    render: react_1.default.createElement(DruhyOsobyUkonOption_1.default, { tlumocnik: tlumocnik }),
}); });
var DruhOsobyUkonForm = function (_a) {
    var onSubmit = _a.onSubmit, druhyOsob = _a.druhyOsob, labels = _a.labels, setSelected = _a.setSelected, filterResult = _a.filterResult, defaultSelected = _a.defaultSelected;
    var apiUrl = ConfigProvider_1.useConfig().apiUrl;
    var getJSON = hooks_1.useGetJSON(apiUrl + "/seek");
    var loadOptions = function (search) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response, filteredResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!search) return [3 /*break*/, 2];
                    params = {
                        keyword: search,
                        idDruhOsoby: druhyOsob,
                    };
                    return [4 /*yield*/, getJSON(params)];
                case 1:
                    response = _a.sent();
                    if (either_1.isRight(response)) {
                        filteredResult = filterResult ? ramda_1.filter(filterResult, response.value) : response.value;
                        return [2 /*return*/, mapToOptions(filteredResult)];
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, []];
            }
        });
    }); };
    return (react_1.default.createElement(Form_1.default, { initialValues: { selected: defaultSelected }, validate: function (v) { return (!v.selected ? { selected: labels === null || labels === void 0 ? void 0 : labels.search } : {}); }, onSubmit: function (values, helpers) {
            if (values.selected) {
                onSubmit(values.selected, helpers);
            }
        } }, function (_a) {
        var isSubmitting = _a.isSubmitting, setFieldValue = _a.setFieldValue, values = _a.values;
        return (react_1.default.createElement(Padder_1.Padder, null,
            (labels === null || labels === void 0 ? void 0 : labels.title) && react_1.default.createElement(DropdownHeader, null, labels === null || labels === void 0 ? void 0 : labels.title),
            react_1.default.createElement(DropdownWrap, null, values.selected ? (react_1.default.createElement(StyledDruhyOsob, { tlumocnik: values.selected, onRemove: function () {
                    setFieldValue('selected', undefined);
                    if (setSelected)
                        setSelected(undefined);
                } })) : (react_1.default.createElement(Dropdown_1.default, { name: "selected", isSearchable: true, placeholder: labels === null || labels === void 0 ? void 0 : labels.search, value: values.selected, onChange: function (_v, option) {
                    setFieldValue('selected', option.data);
                    if (setSelected)
                        setSelected(option.data);
                }, loadOptions: loadOptions, rightIcon: react_1.default.createElement(LoupeIcon_1.default, null) }))),
            react_1.default.createElement(ButtonsWrap, null,
                react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "PridatOsobu" }, (labels === null || labels === void 0 ? void 0 : labels.submit) || 'Přidat'))));
    }));
};
DruhOsobyUkonForm.defaultProps = {
    labels: {
        title: undefined,
        submit: 'Přidat',
        search: undefined,
    },
    filterResult: undefined,
    setSelected: undefined,
    defaultSelected: undefined,
};
exports.default = DruhOsobyUkonForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
